import { useAppContext } from '@/contexts/AppContext';
import type { FC } from 'react';

const CommunityMapSection: FC = () => {
  const { community } = useAppContext();

  if (!community?.map?.url) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold text-gray-900 sm:text-4xl">
            Community Map
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Explore our community layout and find the perfect location for your new home.
          </p>
        </div>

        <div className="relative rounded-none overflow-hidden border border-gray-200">
          <img
            src={community.map?.url}
            alt="Community Map"
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default CommunityMapSection;
